import type { MotifComponent, MotifComponentProps } from '../../motif';
import { subNavigationDefaultVars } from './SubNavigation.palette';

export const snapSubNavigationPrimaryVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
  '--sub-navigation-box-shadow': '0 4px 8px 0 rgba(0, 0, 0, 0.06)',
} as const;
